import axios from "axios";
import { RefreshTokenFunc } from "../Utils/RefreshToken";

import queryStr from "qs";
import { toast } from "react-toastify";
import { store } from "../index";
import { sessionType } from "../redux/actions/user";
//get axios api********************************************************************************************************

export const apiCallPostFunction = async (method, url, ContentType, data) => {
 
  RefreshTokenFunc();
  store.dispatch(sessionType({ what: false }));

  try {
    let response = await axios(url, {
      method: method,
      headers: {
        "Content-Type": ContentType,
        "access-control-allow-origin": "*",
        authorization: "Bearer " + sessionStorage.getItem("access_token"),
      },
      data: queryStr.stringify(data),
    });

    return response;
  } catch (err) {
    if (err.message && err.message.toLowerCase() === "network error") {
      store.dispatch(sessionType({ what: true }));
    } else if (
      err.message &&
      err.message === "Request failed with status code 401"
    ) {
      store.dispatch(sessionType({ what: true }));
    }
    return null;
  }
};
export const greenTokenApiCallPostFunction = async (
  method,
  url,
  ContentType,
  data,
  options = {} // allows headers to be passed in
) => {
  store.dispatch(sessionType({ what: false }));
  try {
    const defaultHeaders = {
      "Content-Type": ContentType,
      "access-control-allow-origin": "*",
      authorization: "Bearer " + sessionStorage.getItem("access_token"),
    };

    let response = await axios(url, {
      method: method,
      headers: {
        ...defaultHeaders,
        ...(options.headers || {}), // merge custom headers like X-Original-User-IP
      },
      data: queryStr.stringify(data),
    });

    return response;
  } catch (err) {
    if (err.message && err.message.toLowerCase() === "network error") {
      store.dispatch(sessionType({ what: true }));
    } else if (
      err.message &&
      err.message === "Request failed with status code 401"
    ) {
      store.dispatch(sessionType({ what: true }));
    } else if (
      err.message &&
      err.message === "Request failed with status code 400"
    ) {
      if (err.response.data?.error_uri === "402") return "Unauthorized";
    }
    return null;
  }
};


//json Stringify
export const apiCallPostFunctionJson = async (
  method,
  url,
  ContentType,
  data
) => {
  RefreshTokenFunc();
  store.dispatch(sessionType({ what: false }));

  try {
    let response = await axios(url, {
      method: method,
      headers: {
        "Content-Type": ContentType,
        "access-control-allow-origin": "*",
        authorization: "Bearer " + sessionStorage.getItem("access_token"),
      },
      data: JSON.stringify(data),
    });

    return response;
  } catch (err) {
    if (err.message && err.message.toLowerCase() === "network error") {
      store.dispatch(sessionType({ what: true }));
    } else if (
      err.message &&
      err.message === "Request failed with status code 401"
    ) {
      store.dispatch(sessionType({ what: true }));
    }
    return null;
  }
};
